import { registerAdapter } from '../adapterRegistry';
import { ColumnAdapter, RowAdapter, CardAdapter, TabsAdapter, ModalAdapter, ListAdapter } from './layoutAdapters';
import {
  TextAdapter,
  ImageAdapter,
  IconAdapter,
  DividerAdapter,
  ProgressBarAdapter,
  BadgeAdapter,
  DateTimeDisplayAdapter,
  ChipListDisplayAdapter,
  GenericDisplayAdapter,
} from './displayAdapters';
import {
  ButtonAdapter,
  TextFieldAdapter,
  CheckboxAdapter,
  DropdownAdapter,
  NumberSliderAdapter,
  BooleanFieldAdapter,
  NumberFieldAdapter,
  DateFieldAdapter,
  DateTimeFieldAdapter,
  UnitFieldAdapter,
  ReferenceFieldAdapter,
  TagListFieldAdapter,
  JsonFieldAdapter,
} from './interactiveAdapters';
import {
  SphereTypeSelectorAdapter,
  SphereCardAdapter,
  UrgencySelectorAdapter,
  PerspectiveDisplayAdapter,
  SphereAvatarAdapter,
  SphereEditorAdapter,
} from './sphereDomainAdapters';
import {
  AtlasAdapter,
  UsersAdapter,
  ProfileAdapter,
  PreferencesAdapter,
  SecurityAdapter,
  TreeMapAdapter,
  ArmillaryViewAdapter,
  ArmillaryActionsAdapter,
  TaskListAdapter,
  ScorecardAdapter,
} from './organismAdapters';
import SpaceGridAdapter from './spaceGridAdapter';
import SectionAdapter from './sectionAdapter';
import ContextShellAdapter from './contextShellAdapter';
import ChartAdapter from './chartAdapter';

/**
 * Registers every catalog entry's adapter. Idempotent (re-registering the same type is a no-op
 * overwrite) so hosts (and tests) can call it freely without guarding against double-invocation.
 */
export function registerBuiltInAdapters(): void {
  // Legacy a2ui primitives (shared `a2ui`/`space` surfaces)
  registerAdapter('Column', ColumnAdapter);
  registerAdapter('Row', RowAdapter);
  registerAdapter('Card', CardAdapter);
  registerAdapter('Tabs', TabsAdapter);
  registerAdapter('Modal', ModalAdapter);
  registerAdapter('List', ListAdapter);
  registerAdapter('Text', TextAdapter);
  registerAdapter('Image', ImageAdapter);
  registerAdapter('Icon', IconAdapter);
  registerAdapter('Divider', DividerAdapter);
  registerAdapter('ProgressBar', ProgressBarAdapter);
  registerAdapter('Badge', BadgeAdapter);
  registerAdapter('Button', ButtonAdapter);
  registerAdapter('TextField', TextFieldAdapter);
  registerAdapter('CheckBox', CheckboxAdapter);
  registerAdapter('Dropdown', DropdownAdapter);
  registerAdapter('NumberSlider', NumberSliderAdapter);
  registerAdapter('SphereTypeSelector', SphereTypeSelectorAdapter);
  registerAdapter('SphereCard', SphereCardAdapter);
  registerAdapter('UrgencySelector', UrgencySelectorAdapter);
  registerAdapter('PerspectiveDisplay', PerspectiveDisplayAdapter);
  registerAdapter('SphereAvatar', SphereAvatarAdapter);
  registerAdapter('SphereEditor', SphereEditorAdapter);

  // Metaspace organisms (`metaspace`/`space` surfaces)
  registerAdapter('Atlas', AtlasAdapter);
  registerAdapter('Users', UsersAdapter);
  registerAdapter('Profile', ProfileAdapter);
  registerAdapter('Preferences', PreferencesAdapter);
  registerAdapter('Security', SecurityAdapter);
  registerAdapter('TreeMap', TreeMapAdapter);
  registerAdapter('ArmillaryView', ArmillaryViewAdapter);
  registerAdapter('ArmillaryActions', ArmillaryActionsAdapter);
  registerAdapter('task-list', TaskListAdapter);
  registerAdapter('Scorecard', ScorecardAdapter);

  // Space surface primitives (`space`-only)
  registerAdapter('SpaceGrid', SpaceGridAdapter);
  registerAdapter('Section', SectionAdapter);
  registerAdapter('ContextShell', ContextShellAdapter);
  registerAdapter('Chart', ChartAdapter);

  // Renderer primitives (EAINT-855) — `TYPE_DEFAULT_RENDERERS`' per-data-type default table.
  registerAdapter('BooleanField', BooleanFieldAdapter);
  registerAdapter('NumberField', NumberFieldAdapter);
  registerAdapter('DateField', DateFieldAdapter);
  registerAdapter('DateTimeField', DateTimeFieldAdapter);
  registerAdapter('UnitField', UnitFieldAdapter);
  registerAdapter('ReferenceField', ReferenceFieldAdapter);
  registerAdapter('TagListField', TagListFieldAdapter);
  registerAdapter('JsonField', JsonFieldAdapter);
  registerAdapter('DateTimeDisplay', DateTimeDisplayAdapter);
  registerAdapter('ChipListDisplay', ChipListDisplayAdapter);
  registerAdapter('GenericDisplay', GenericDisplayAdapter);
}
